import { render, staticRenderFns } from "./JobRoundDisplay.vue?vue&type=template&id=7519551e&"
import script from "./JobRoundDisplay.vue?vue&type=script&lang=js&"
export * from "./JobRoundDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports